import React, { forwardRef } from 'react';
import { cx } from '@linaria/atomic';
import Children from 'react-children-utilities';
import { dropdownInputContainer, dropdownInputHidden } from './dropdown-input.styles';
import type { InputProps } from './types';

type Props = InputProps<'dropdown'> & {
  as?: keyof JSX.IntrinsicElements;
  className?: string;
  displayValue?: React.ReactNode;
};

// This input is set up this way to be able
// to display custom content (children of selected option)
// It contains the minimal amount of styling needed for its use case
export const DropdownInput = forwardRef<HTMLInputElement, Props>(
  ({ className, as = 'p', displayValue, placeholder, ...rest }, ref) => {
    const Component = as;
    return (
      <Component className={cx(dropdownInputContainer, className)}>
        <input
          {...rest}
          /**
           * Display the text shown in each option as selected value (not the option value)
           */
          value={Children.onlyText(displayValue as React.ReactNode)}
          className={dropdownInputHidden}
          type='text'
          readOnly
          ref={ref}
        />
        {displayValue || rest.value || placeholder}
      </Component>
    );
  }
);
